export const actionSubjects = {
  LOGIN: 'לוגין',
  LOGOUT: 'לוגאוט',
  CHANGE_PASSWORD: 'שינוי סיסמה',
  LOGIN_BY_PHONE: 'לוגין דרך סמס',
  LOGIN_AS_ADMIN: 'לוגין כאדמין',
  ORDER_INVOICE: 'הזמנת חשבונית',
  CANCEL_INVOICE: 'ביטול חשבונית',
  GET_PAYMENT_CREDIT_CARD: 'תשלום בכרטיס אשראי',
  GET_PAYMENT_BIT: 'תשלום בביט',
  GET_PAYMENT_RECURRING: 'תשלום בהוראת קבע',
  GET_PAYMENT_PAYPAL: 'תשלום בפייפאל',
  INVITE_FRIEND: 'הזמנת חבר',
}